import { useGSAP } from "@gsap/react"
import clsx from "clsx"
import gsap from "gsap"
import { Draggable } from "gsap/Draggable"
import { FC, useEffect, useRef, useState } from "react"
import { IRange } from "."
import styles from "./Range.module.scss"

export const Range: FC<IRange> = ({
  onChange,
  min,
  max,
  step,
  defaultValue,

  className,
  ...props
}) => {
  const [value, setValue] = useState<number>(defaultValue ?? min)

  const refRange = useRef<HTMLDivElement>(null)
  const refTongue = useRef<HTMLDivElement>(null)
  const refTongueBack = useRef<HTMLDivElement>(null)
  const draggableRef = useRef<Draggable | null>(null)

  function scaleNumber(number: number) {
    const scaled = number * (max - min) + min
    const newValue = Math.floor(scaled / step) * step

    if (newValue > max) {
      return max
    }

    return newValue
  }

  useEffect(() => {
    onChange(value)
  }, [value])

  useGSAP(() => {
    if (!refRange.current || !refTongue.current) return

    const draggable = Draggable.create(refTongue.current, {
      type: "x",
      bounds: refRange.current,
      inertia: false,
      liveSnap: {
        x: function (value) {
          return Math.round(value / 0.5) * 0.5
        }
      },
      onDrag() {
        if (refRange.current && refTongue.current) {
          let progressCur = this.endX / this.maxX

          if (progressCur < 0.001) {
            progressCur = 0
          }

          const outputNumber = scaleNumber(progressCur)

          setValue(outputNumber)
          onChange(outputNumber)

          gsap.set(refTongueBack.current, {
            width: `${this.x + 5}px`
          })
        }
      }
    })

    draggableRef.current = draggable[0]
  }, [min, max, step])

  useEffect(() => {
    if (!refRange.current || !refTongue.current) return

    const progress = (value - min) / (max - min)
    const maxX = refRange.current.offsetWidth - refTongue.current.offsetWidth
    const initialX = progress * maxX

    gsap.set(refTongue.current, {
      clearProps: true
    })
    gsap.set(refTongue.current, { x: initialX })
    gsap.set(refTongueBack.current, { width: `${initialX + 5}px` })
  }, [])

  return (
    <div className={clsx(styles.Range, className)} {...props}>
      <div className={clsx(styles.Range_drag)}>
        <div className={clsx(styles.Range_dragBox)} ref={refRange}>
          <div className={clsx(styles.Range_tongueBack)} ref={refTongueBack}>
            <div className={clsx(styles.Range_tongueBack_inner)} />
          </div>
          <div className={clsx(styles.Range_tongue)} ref={refTongue} />
        </div>
      </div>
      <div className={clsx(styles.Range_diapason)}>
        <div className={clsx(styles.Range_diapason_item)}>
          {min.toLocaleString("en-US", {
            useGrouping: true
          })}
        </div>
        <div className={clsx(styles.Range_diapason_item)}>
          {max.toLocaleString("en-US", {
            useGrouping: true
          })}
        </div>
      </div>
    </div>
  )
}
